// Check if password length is between 8-12 characters
const hasValidLength = (password) => password.length >= 8 && password.length <= 12;

// has number
const hasNumber = (password) => new RegExp(/[0-9]/).test(password);

// has both lowercase and uppercase
const hasMixedCase = (password) => new RegExp(/[a-z]/).test(password) && new RegExp(/[A-Z]/).test(password);

// set color based on password strength
export const strengthColor = (count) => {
  if (count < 2) return { label: 'Weak', color: 'error.main' };
  if (count < 3) return { label: 'Medium', color: 'warning.main' };
  if (count === 3) return { label: 'Strong', color: 'success.main' };
  return { label: 'Weak', color: 'error.main' };
};

// password strength indicator - 3 requirements
export const strengthIndicator = (password) => {
  let strengths = 0;
  if (hasValidLength(password)) strengths += 1;
  if (hasNumber(password)) strengths += 1;
  if (hasMixedCase(password)) strengths += 1;
  return strengths;
};

// Get detailed requirements status
export const getPasswordRequirements = (password) => {
  return [
    { label: 'Password length 8-12 characters', met: hasValidLength(password) },
    { label: 'Include at least one number', met: hasNumber(password) },
    { label: 'Include uppercase and lowercase letters', met: hasMixedCase(password) }
  ];
};
